// extracted by mini-css-extract-plugin
export var h1Heading = "heading-module--h1Heading--59ad5";
export var h2Heading = "heading-module--h2Heading--f47c6";
export var h3Heading = "heading-module--h3Heading--4f13c";
export var h4Heading = "heading-module--h4Heading--3f2a3";
export var h5Heading = "heading-module--h5Heading--e0aa2";
export var h6Heading = "heading-module--h6Heading--0f23b";